import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import './checkoutTabs.scss';
import { TabView, TabPanel } from 'primereact/tabview';

import { Button } from 'primereact/button';
import CheckoutGettingStarted from '../components/CheckoutGettingStarted';
import CheckoutContactInfo from '../components/CheckoutContactInfo';
import CheckoutSecurePayment from '../components/CheckoutSecurePayment';
import CheckoutConfirmedForm from '../components/CheckoutConfirmedForm';
import CheckoutPricingOrderComplete from '../components/CheckoutPricingOrderComplete';
import CheckoutMSA from '../components/CheckoutMSA';
import { fetchData } from '../services/fetchData';
import saveOrder from '../services/saveOrder';
import OrderFail from '../components/OrderFail';
import downloadMSA from '../services/downloadMSA';
import { isValidEmail } from '../utils/helpers';

function CheckoutTabs() {
  const [selectedCard, setSelectedCard] = useState(null);
  const history = useHistory();

  const [loadingOrderCheckout, setLoadingOrderCheckout] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [price, setPrice] = useState(null);

  useEffect(() => {
    const selectedPackage = history?.location?.state?.data?.selected;
    if (selectedPackage) {
      setSelectedCard(selectedPackage);
    } else {
      history.push('/homepricing');
    }
    setPrice(history?.location?.state?.data?.selected);
  }, [history]);

  useEffect(async () => {
    setLoading(true);
    const response = await fetchData();
    setData(response);
    setLoading(false);
  }, []);

  const [formErrors, setformErrors] = useState({});
  const [form, setForm] = useState({
    businessName: '',
    industry: '',
    businessEmail: '',
    businessEmailConfirmation: '',
    firstName: '',
    lastName: '',
    role: '',
    phone: '',
    socialByUpShow: false,
    socialHandle: false,
    mediaAccount: '',
    noSocial: true,
    businessAddress: '',
    businessAddress2: '',
    zipCode: '',
    city: '',
    state: '',
    country: 'United States',
    shippingATTN: '',
    shippingBusinessAddress: '',
    shippingBusinessAddress2: '',
    shippingZipCode: '',
    shippingState: '',
    shippingCountry: 'United States',
    shippingCity: '',
    billingAddress: '',
    billingAddress2: '',
    billingZipCode: '',
    billingState: '',
    billingCountry: 'United States',
    billingCity: '',
    useBusinessAddressForBilling: false,
    useBusinessAddressForShipping: false,
    agree: false,
    creditCard: '',
    paymentMethod: undefined,
    numberOfDevices: 1,
    numberOfLocations: 1,
    socialMedia: '',
  });
  const [draftOrder, setDraftOrder] = useState({});

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setformErrors({ ...formErrors, [e.target.name]: null });
  };

  const validateStep1 = () => {
    setformErrors({
      ...formErrors,
      businessName: !form.businessName.length ? 'This information is required' : null,
      industry: !form.industry.length ? 'This information is required' : null,
      businessAddress: !form.businessAddress.length ? 'This information is required' : null,
      zipCode: !form.zipCode.length ? 'This information is required' : null,
      state: !form.state.length ? 'This information is required' : null,
      country: !form.country.length ? 'This information is required' : null,
      city: !form.city.length ? 'This information is required' : null,
    });
    return (
      form.businessName.length &&
      form.industry.length &&
      form.businessAddress.length &&
      form.city.length &&
      form.zipCode.length &&
      form.state.length &&
      form.country.length
    );
  };

  const validateStep2 = () => {
    const emailIsValid = isValidEmail(form.businessEmail);
    const confirmationIsValid = form.businessEmailConfirmation === form.businessEmail;

    setformErrors({
      ...formErrors,
      shippingATTN: !form.shippingATTN.length ? 'This information is required' : null,
      businessEmail: !emailIsValid ? 'Invalid email' : null,
      businessEmailConfirmation: !confirmationIsValid ? 'Emails should match' : null,
      firstName: !form.firstName.length ? 'This information is required' : null,
      lastName: !form.lastName.length ? 'This information is required' : null,
      phone: !form.phone.length ? 'This information is required' : null,
      shippingBusinessAddress: !form.shippingBusinessAddress.length ? 'This information is required' : null,
      shippingCity: !form.shippingCity.length ? 'This information is required' : null,
      shippingZipCode: !form.shippingZipCode.length ? 'This information is required' : null,
      shippingState: !form.shippingState.length ? 'This information is required' : null,
      shippingCountry: !form.shippingCountry.length ? 'This information is required' : null,
    });
    return (
      form.shippingATTN.length &&
      emailIsValid &&
      confirmationIsValid &&
      form.firstName.length &&
      form.lastName.length &&
      form.phone.length &&
      form.shippingBusinessAddress.length &&
      form.shippingCity.length &&
      form.shippingZipCode.length &&
      form.shippingState.length &&
      form.shippingCountry.length
    );
  };
  const validateStep3 = () => {
    setformErrors({
      ...formErrors,
      billingAddress: !form.billingAddress.length ? 'This information is required' : null,
      billingZipCode: !form.billingZipCode.length ? 'This information is required' : null,
      billingState: !form.billingState.length ? 'This information is required' : null,
      billingCity: !form.billingCity.length ? 'This information is required' : null,
      billingCountry: !form.billingCountry.length ? 'This information is required' : null,
      paymentMethod: form.paymentMethod !== undefined ? 'This information is required' : null,
    });
    return (
      form.billingAddress.length &&
      form.billingZipCode.length &&
      form.billingState.length &&
      form.billingCity.length &&
      form.billingCountry.length &&
      form.paymentMethod !== undefined
    );
  };

  const saveDraftOrder = async () => {
    const draftBody = {
      id: draftOrder.id,
      packageName: price.title,
      step: activeIndex + 1,
      businessName: form.businessName,
      industry: form.industry,
      email: form.businessEmail,
      name: form.firstName,
      lastName: form.lastName,
      role: form.role,
      phone: form.phone,
      businessStreet: form.businessAddress,
      businessStreet2: form.businessAddress2,
      businessCity: form.city,
      businessZipCode: form.zipCode,
      businessState: form.state,
      businessCountry: form.country,
      billingStreet: form.billingAddress,
      billingStreet2: form.billingAddress2,
      billingCity: form.billingCity,
      billingZipCode: form.billingZipCode,
      billingState: form.billingState,
      billingCountry: form.billingCountry,
      shippingATTN: form.shippingATTN,
      shippingStreet: form.shippingAddress,
      shippingStreet2: form.shippingAddress2,
      shippingCity: form.shippingCity,
      shippingZipCode: form.shippingZipCode,
      shippingState: form.shippingState,
      shippingCountry: form.shippingCountry,
    };
    const { data: savedDraftOrder } = await axios.post(
      `${process.env.REACT_APP_BILLING_BASE_URL}selfserve/draftOrder`,
      draftBody,
    );

    setDraftOrder({ ...draftBody, id: savedDraftOrder.data.id });
  };

  const handleNext = async () => {
    let isValid = false;

    if (loading) return;

    switch (activeIndex) {
      case 0: {
        if (validateStep1()) {
          setActiveIndex(activeIndex + 1);
          isValid = true;
        }

        break;
      }
      case 1: {
        if (validateStep2()) {
          setActiveIndex(activeIndex + 1);
          isValid = true;
        }

        break;
      }
      case 2: {
        if (validateStep3()) {
          setActiveIndex(activeIndex + 1);
          isValid = true;
        }

        break;
      }
      case 3: {
        if (validateStep3()) {
          setActiveIndex(activeIndex + 1);
          isValid = true;
        }

        break;
      }
      case 4: {
        setLoadingOrderCheckout(true);
        const result = await saveOrder({
          ...form,
          activationCharge: price.title === 'Starter' ? data?.device?.id : data?.device_subscription?.id,
          subscriptionCharge: price.priceId,
          shippingCharge: data?.ground_shipping?.id,
          chargesActivationCharge: parseFloat(price.priceText.split('$')[1]) + form.numberOfDevices * data?.device?.price,
          chargesSubscriptionCharge: parseFloat(price.priceText.split('$')[1]),
          chargesShippingCharge: data?.ground_shipping?.price,
        });
        setLoadingOrderCheckout(false);
        setShowErrorMessage(!result);
        if (result && result.data.customerRejected) {
          if (result.data.code === 'email_invalid') {
            setShowErrorMessage(true);
          } else {
            setShowErrorPopup(true);
          }
        } else if (result && result.data.signedMSA) {
          setShowSuccessMessage(true);
          await downloadMSA(result.data.signedMSA);
        }

        isValid = true;

        break;
      }
      default:
        break;
    }

    if (isValid) {
      try {
        await saveDraftOrder();
      } catch (e) {
        console.log(e);
      }
    }
  };

  const handleBack = () => {
    setActiveIndex(activeIndex - 1);
  };

  const renderButtons = () => {
    return (
      <div className="btns_box col-12 flex align-items-center justify-content-start">
        <div className="buttons">
          <div id="checkout-button">
            {activeIndex !== 0 && (
              <Button className="back_btn" type="submit" onClick={handleBack} label="Back" icon="" iconPos="right" />
            )}
          </div>
          <div id="checkout-button">
            <Button type="submit" onClick={handleNext} label={getLabel()} icon="" iconPos="right" className="btn-magenta" />
          </div>
        </div>
      </div>
    );
  };

  const tabHeaderGettingStarted = options => {
    return (
      <div className="flex align-items-center justify-content-center" onKeyUp={options.handleKeyUp} role="button" tabIndex={0}>
        <div className="flex flex-column tab_item">
          <div className="tab_number">1</div>
          <p className="tab_title">Getting Started</p>
        </div>
        <span className="divider" />
      </div>
    );
  };

  const tabHeaderContactInfo = options => {
    return (
      <div className="flex align-items-center justify-content-center" onKeyUp={options.handleKeyUp} role="button" tabIndex={0}>
        <div className="flex flex-column tab_item">
          <div className="tab_number">2</div>
          <p className="tab_title">Contact Information</p>
        </div>
        <span className="divider" />
      </div>
    );
  };

  const tabHeaderSecurePayment = options => {
    return (
      <div className="flex align-items-center justify-content-center" onKeyUp={options.handleKeyUp} role="button" tabIndex={0}>
        <div className="flex flex-column tab_item">
          <div className="tab_number">3</div>
          <p className="tab_title">Secure Payment</p>
        </div>
        <span className="divider" />
      </div>
    );
  };

  const tabHeaderMSA = options => {
    return (
      <div className="flex align-items-center justify-content-center" onKeyUp={options.handleKeyUp} role="button" tabIndex={0}>
        <div className="flex flex-column tab_item">
          <div className="tab_number">4</div>
          <p className="tab_title">Service Agreement</p>
        </div>
        <span className="divider" />
      </div>
    );
  };

  const tabHeaderConfirmOrder = options => {
    return (
      <div onKeyUp={options.handleKeyUp} role="button" tabIndex={0}>
        <div className="flex flex-column tab_item">
          <div className="tab_number">5</div>
          <p className="tab_title">Confirm Order</p>
        </div>
      </div>
    );
  };

  const getLabel = () => {
    if (activeIndex === 4) {
      return 'Submit Order';
    }
    if (activeIndex === 3) {
      return 'Sign and Continue';
    }

    return 'Save and Continue';
  };
  const goToBilling = () => {
    setActiveIndex(activeIndex - 2);
    setShowErrorPopup(false);
  };

  return loadingOrderCheckout ? (
    <div className="flex justify-content-center align-items-center" style={{ width: '100%', height: '100vh' }}>
      <div className="flex align-self-center justify-content-center">
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em', color: '#da39ff' }} />
      </div>
    </div>
  ) : (
    <div id="checkOut">
      {showSuccessMessage ? (
        <div>
          <CheckoutPricingOrderComplete />
        </div>
      ) : null}
      {showErrorMessage && <OrderFail />}
      {showErrorPopup && (
        <div className="error-popup">
          <button type="button" className="close" onClick={() => setShowErrorPopup(false)}>
            X
          </button>
          <h2>Payment Failed</h2>
          <p>We are unable to process payment on your current card. Please update your card information and try again</p>
          <Button
            type="button"
            onClick={goToBilling}
            label="Go to Billing Information"
            icon=""
            iconPos="right"
            className="pop-button"
          />
        </div>
      )}
      {!loadingOrderCheckout && !showSuccessMessage && (
        <div className="grid">
          <div className="col-12 header-checkout">
            <h1>Checkout</h1>
          </div>
          <div className="col-12">
            <TabView activeIndex={activeIndex} onTabChange={e => setActiveIndex(e.index)}>
              <TabPanel headerTemplate={tabHeaderGettingStarted}>
                <CheckoutGettingStarted
                  selectedCard={selectedCard}
                  formErrors={formErrors}
                  loading={loading}
                  devicePrice={data?.device?.price}
                  values={form}
                  updateForm={handleChange}
                  devicePriceFee={data?.device_subscription?.price}
                  shippingPriceFee={data?.ground_shipping?.price}
                  setPrice={setPrice}
                  renderButtons={renderButtons}
                />
              </TabPanel>
              <TabPanel headerTemplate={tabHeaderContactInfo}>
                <CheckoutContactInfo
                  selectedCard={selectedCard}
                  formErrors={formErrors}
                  values={form}
                  updateForm={handleChange}
                  devicePrice={data?.device?.price}
                  devicePriceFee={data?.device_subscription?.price}
                  shippingPriceFee={data?.ground_shipping?.price}
                  setForm={setForm}
                  renderButtons={renderButtons}
                />
              </TabPanel>
              <TabPanel headerTemplate={tabHeaderSecurePayment}>
                <CheckoutSecurePayment
                  selectedCard={selectedCard}
                  formErrors={formErrors}
                  values={form}
                  updateForm={handleChange}
                  setForm={setForm}
                  devicePrice={data?.device?.price}
                  devicePriceFee={data?.device_subscription?.price}
                  shippingPriceFee={data?.ground_shipping?.price}
                  renderButtons={renderButtons}
                />
              </TabPanel>
              <TabPanel values={form} headerTemplate={tabHeaderMSA}>
                <CheckoutMSA
                  selectedCard={selectedCard}
                  values={form}
                  devicePrice={data?.device?.price}
                  shippingFee={data?.ground_shipping?.price}
                  renderButtons={renderButtons}
                />
              </TabPanel>
              <TabPanel values={form} headerTemplate={tabHeaderConfirmOrder}>
                <CheckoutConfirmedForm
                  selectedCard={selectedCard}
                  updateForm={handleChange}
                  setForm={setForm}
                  values={form}
                  devicePrice={data?.device?.price}
                  devicePriceFee={data?.device_subscription?.price}
                  shippingPriceFee={data?.ground_shipping?.price}
                  renderButtons={renderButtons}
                />
              </TabPanel>
            </TabView>
          </div>
        </div>
      )}
    </div>
  );
}

export default CheckoutTabs;
